// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "nav_next-27Ys7";
var _3 = "nav_prev-18CoI";
export { _1 as "__esModule", _2 as "nav_next", _3 as "nav_prev" }
export default { "__esModule": _1, "nav_next": _2, "nav_prev": _3 }
